module.exports = __webpack_public_path__ + "img/content_copy.712552c6.svg";